import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import MenuSelectModal from "../common/MenuSelectModal";
import UserSelectModal from "../common/UserSelectModal";
import ResourceSelectModal from "../common/ResourceSelectModal";

function AuthorityRegModal({ title, onClose, handleRegSuccessSave, authorityTypeModalOption, deptModalOption, positionModalOption, dutyModalOption, MenuUpdateYN}) {
  const appStore = useContext(AppContext);
  const apiRef = useGridApiRef();
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    authority_id: null,
    authority_name: '',
    authority_type: '',
    authority_desc: ''
  });
  const YNOption = [{value:'Y', label:'Y'}, {value:'N', label:'N'}];
  const [menuRows, setMenuRows] = useState([]);
  const [updateMenuRows, setUpdateMenuRows] = useState([]);
  const [menuColumns, setMenuColumns] = useState([]);
  const [menuColumnVisibilityModel, setMenuColumnVisibilityModel] = useState({
    id: false,
    actions: true,
    menu_id: false,
    menu_name: true,
    menu_update_exist_yn: true,
    menu_delete_exist_yn: true,
    menu_update_yn: true,
    menu_delete_yn: true,
    row_type: false,
    update_type: false
  });
  const [userRows, setUserRows] = useState([]);
  const [updateUserRows, setUpdateUserRows] = useState([]);
  const [userColumns, setUserColumns] = useState([]);
  const [userColumnVisibilityModel, setUserColumnVisibilityModel] = useState({
    id: false,
    actions: true,
    dept_id: true,
    position: true,
    duty: true,
    user_id: false,
    user_name: true,
    row_type: false,
    update_type: false
  });
  const [resourceRows, setResourceRows] = useState([]);
  const [updateResourceRows, setUpdateResourceRows] = useState([]);
  const [resourceColumns, setResourceColumns] = useState([]);
  const [resourceColumnVisibilityModel, setResourceColumnVisibilityModel] = useState({
      id: false,
      actions: true,
      resource_id: false,
      resource_name: true,
      resource_number: true,
      resource_workplace_name: true,
      resource_location: true,
      row_type: false,
      update_type: false
    });
  const [selectmodalTitle, setSelectModalTitle] = useState('');
  const [isSelectModalOpen, setSelectModalOpen] = useState(false);
  const [selectMenuData, setSelectMenuData] = useState('');
  const [selectusermodalTitle, setSelectUserModalTitle] = useState('');
  const [isSelectUserModalOpen, setSelectUserModalOpen] = useState(false);
  const [selectUserData, setSelectUserData] = useState('');
  const [selectresourcemodalTitle, setSelectResourceModalTitle] = useState('');
  const [isSelectResourceModalOpen, setSelectResourceModalOpen] = useState(false);
  const [selectResourceData, setSelectResourceData] = useState('');

  useEffect(() => {
      // Mount 될때만 실행된다.
      handleSetting();
  }, [title]);

  useEffect(() => {
    let ADD_YN= 'Y'
    for(let i=0; i<menuRows.length; i++){
      if(menuRows[i].row_type === 'A' && menuRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }

    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setMenuRows((menuRows) => [...menuRows, { 
        id: Number(appStore.getMaxListID(menuRows))+1,
        menu_id: '',
        menu_name: '',
        menu_update_exist_yn: 'N',
        menu_delete_exist_yn: 'N',
        menu_update_yn: 'N',
        menu_delete_yn: 'N',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [menuRows]);

  useEffect(() => {
    let ADD_YN= 'Y'
    for(let i=0; i<userRows.length; i++){
      if(userRows[i].row_type === 'A' && userRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }

    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        dept_id: '',
        position: '',
        duty: '',
        user_id: '',
        user_name: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [userRows]);

  useEffect(() => {
    let ADD_YN= 'Y'
    for(let i=0; i<resourceRows.length; i++){
      if(resourceRows[i].row_type === 'A' && resourceRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }

    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setResourceRows((resourceRows) => [...resourceRows, { 
        id: Number(appStore.getMaxListID(resourceRows))+1,
        resource_id: '',
        resource_name: '',
        resource_number: '',
        resource_workplace_name: '',
        resource_location: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [resourceRows]);

  useEffect(() => {
      //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    setTabPanelHeight(tabPanelRef.current.clientHeight);
  }, []);

  const onSelectChange = (type, value) => {
    const nextInputs = {
        ...inputs,
        [type] : value
    };
    setInputs(nextInputs);

    if(value === 'authority_type'){
      //권한유형 변경 시 계정권한, 자원권한 초기화
      setUserRows([]);
      setUpdateUserRows([]);
    }
  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const handleSetting = () => {
    setMenuColumns([
      (MenuUpdateYN === "Y"?
        {
            field: 'actions',
            headerName: '동작',
            width: 55,
            type:'actions',
            disableClickEventBubbling: true,
            getActions: (params) => [
                ((params.row.update_type === "U")? 
                <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {menuDeleteClick(params)}} label="Delete" />
                : (MenuUpdateYN === "Y" && params.row.row_type === "A" && params.row.update_type === "N")? 
                <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {menuAddClick(params)}} label="Add"  /> 
                :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {menuDeleteClick(params)}} label="Delete" />
                )
              ],
            headerAlign: 'center', 
            align:'center'
        } : {}),
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'menu_id', headerName: 'menu_id', width: 0, headerAlign: 'center' },
      { field: 'menu_name', headerName: '화면명', width: 200, headerAlign: 'center', align:'center' },
      { field: 'menu_update_exist_yn', headerName: '화면수정권한존재', width: 150, cellClassName: 'datagrid-disabled', headerAlign: 'center', align:'center' },
      { field: 'menu_delete_exist_yn', headerName: '화면삭제권한존재', width: 150, cellClassName: 'datagrid-disabled', headerAlign: 'center', align:'center' },
      { field: 'menu_update_yn', headerName: '수정권한', type: 'singleSelect', width: 100, editable: true,
        cellClassName: (params) => { return (params.row.menu_update_exist_yn === 'N')? 'datagrid-disabled':'' },
        valueOptions: ({ row }) => { return (row.menu_update_exist_yn === 'Y')? YNOption:[{value:'N', label:'N'}] }, valueFormmatter: ({ value }) => YNOption.find((opt) => String(opt.value) === String(value))?.label ?? '', headerAlign: 'center', align:'center' },
      { field: 'menu_delete_yn', headerName: '삭제권한', type: 'singleSelect', width: 100, editable: true,
        cellClassName: (params) => { return (params.row.menu_delete_exist_yn === 'N')? 'datagrid-disabled':'' },
        valueOptions: ({ row }) => { return (row.menu_delete_exist_yn === 'Y')? YNOption:[{value:'N', label:'N'}] }, valueFormmatter: ({ value }) => YNOption.find((opt) => String(opt.value) === String(value))?.label ?? '', headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);


    setUserColumns([
      (MenuUpdateYN === "Y"?
        {
            field: 'actions',
            headerName: '동작',
            width: 55,
            type:'actions',
            disableClickEventBubbling: true,
            getActions: (params) => [
                ((params.row.update_type === "U")? 
                <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
                : (params.row.row_type === "A" && params.row.update_type === "N")? 
                <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {userAddClick(params)}} label="Add"  /> 
                :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
                )
              ],
            headerAlign: 'center', 
            align:'center'
        } : {}),
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'dept_id', headerName: '부서', type: 'singleSelect', width: 150, editable: true,
        valueOptions: ({ row }) => { return deptModalOption }, valueFormmatter: ({ value }) => deptModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '', headerAlign: 'center', align:'center' },
      { field: 'position', headerName: '직위', type: 'singleSelect', width: 120, editable: true,
        valueOptions: ({ row }) => { return positionModalOption }, valueFormmatter: ({ value }) => positionModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '', headerAlign: 'center', align:'center' },
      { field: 'duty', headerName: '직책', type: 'singleSelect', width: 120, editable: true,
        valueOptions: ({ row }) => { return dutyModalOption }, valueFormmatter: ({ value }) => dutyModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '', headerAlign: 'center', align:'center' },
      { field: 'user_id', headerName: 'user_id', width: 0, headerAlign: 'center' },
      { field: 'user_name', headerName: '사용자', width: 120, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setResourceColumns([
      (MenuUpdateYN === "Y"?
        {
            field: 'actions',
            headerName: '동작',
            width: 55,
            type:'actions',
            disableClickEventBubbling: true,
            getActions: (params) => [
                ((params.row.update_type === "U")? 
                <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {resouceDeleteClick(params)}} label="Delete" />
                : (params.row.row_type === "A" && params.row.update_type === "N")? 
                <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {resouceAddClick(params)}} label="Add"  /> 
                :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {resouceDeleteClick(params)}} label="Delete" />
                )
              ],
            headerAlign: 'center', 
            align:'center'
        } : {}),
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'resource_id', headerName: 'resource_id', width: 0, headerAlign: 'center' },
      { field: 'resource_name', headerName: '자원명', width: 150, headerAlign: 'center', align:'left' },
      { field: 'resource_number', headerName: '자원번호', width: 120, cellClassName: 'datagrid-disabled', headerAlign: 'center', align:'center' },
      { field: 'resource_workplace_name', headerName: '자원사업장', width: 135, cellClassName: 'datagrid-disabled', headerAlign: 'center', align:'left' },
      { field: 'resource_location', headerName: '자원위치', width: 120, cellClassName: 'datagrid-disabled', headerAlign: 'center', align:'left' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);
  };
  
  const handleSave = (event) => {
    let msg = '';
    if((inputs.authority_name).trim() === ''){
      msg = '권한명은 필수 입력 입니다.'
    }else if(inputs.authority_type === ''){
      msg = '권한유형은 필수 선택 입니다.';
    }

    if(updateMenuRows.length > 0 && msg === ''){
      for(let i = 0; i < updateMenuRows.length; i++) {
        const authority_menu_id = updateMenuRows[i].menu_id;

        if(authority_menu_id === '' ) {
          msg = '입력되지 않은 권한 메뉴가 존재합니다.';
          break;
        }
      }
    }

    if(updateUserRows.length > 0 && msg === ''){
      for(let i = 0; i < updateUserRows.length; i++) {
        const authority_dept_id = updateUserRows[i].dept_id;
        const authority_position = updateUserRows[i].position;
        const authority_duty = updateUserRows[i].duty;
        const authority_user_id = updateUserRows[i].user_id;

        if(authority_dept_id === '' && authority_position === '' && authority_duty === '' && authority_user_id === '') {
          msg = '입력되지 않은 계정 권한이 존재합니다.';
          break;
        }
      }
    }

    if(updateResourceRows.length > 0 && msg === ''){
      for(let i = 0; i < updateResourceRows.length; i++) {
        const authority_resource_id = updateResourceRows[i].resource_id;
        
        if(authority_resource_id === '') {
          msg = '입력되지 않은 자원 권한이 존재합니다.';
          break;
        }
      }
    }

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">권한 등록 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }else{
      if (appStore.loading) return;
      appStore.setLoading(true);
      
      axios.post("/api/p/Authority/Reg", {inputs, updateMenuRows, updateUserRows, updateResourceRows},
      { withCredentials: true })
      .then(function (response) {
        if(response.status === 200){
          handleRegSuccessSave(response.data);
        }else{
          appStore.capture();
        }
      })
      .catch(function (error) {
          appStore.capture();
      })
      .finally(() => {
          appStore.setLoading(false); 
      });

    }
  };

  const handleMenuOnCellClick = (params) => {
    if(params.field === 'menu_name'){
      setSelectModalTitle('화면 목록')
      setSelectModalOpen(true);
      setSelectMenuData({
        id : params.row.id,
        menu_id : params.row.menu_id,
        item_in_out_type: params.row.menu_name,
        menu_update_exist_yn: params.row.menu_update_exist_yn,
        menu_delete_exist_yn: params.row.menu_delete_exist_yn,
        menu_update_yn: params.row.menu_update_yn,
        menu_delete_yn: params.row.menu_delete_yn,
        row_type: params.row.row_type,
        update_type: params.row.update_type
      })
    }
  }

  const handleMenuClick = (object) => {
    if(object.id !== selectMenuData.menu_id){
      var doubleYN = 'N'; //updateRows에 있는값인지 확인함.
      for (let i = 0; i < menuRows.length; i++) {
        if(menuRows[i].menu_id === object.id && selectMenuData.id !== menuRows[i].id && object.id !== ''){
          doubleYN = 'Y';
        }
      }

      if(doubleYN === 'Y'){
        Swal.fire({
          title: '<p style="color:red">화면 '+object.menu_name+' 중복</p>',
          text: '추가된 화면이므로, 중복으로 추가할 수 없습니다.',
          confirmButtonText: '확인'
        });
      }else{
        processMenuRowUpdate(
          {
            id : selectMenuData.id,
            menu_id : object.id,
            menu_name: object.menu_name,
            menu_update_exist_yn: object.menu_update_exist_yn,
            menu_delete_exist_yn: object.menu_delete_exist_yn,
            menu_update_yn: object.menu_update_exist_yn,
            menu_delete_yn: object.menu_delete_exist_yn,
            row_type: selectMenuData.row_type,
            update_type: selectMenuData.update_type,
            editable:false
          },
          {
            id : selectMenuData.id,
            menu_id : selectMenuData.menu_id,
            menu_name: selectMenuData.menu_name,
            menu_update_exist_yn: selectMenuData.menu_update_exist_yn,
            menu_delete_exist_yn: selectMenuData.menu_delete_exist_yn,
            menu_update_yn: selectMenuData.menu_update_yn,
            menu_delete_yn: selectMenuData.menu_delete_yn,
            row_type: selectMenuData.row_type,
            update_type: selectMenuData.update_type
          }
        );
      }
    }
  }

  const menuAddClick = (object) => {
    //화면 추가 버튼
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setMenuRows((menuRows) => [...menuRows, { 
        id: Number(appStore.getMaxListID(menuRows))+1,
        menu_id: '',
        menu_name: '',
        menu_update_exist_yn: 'N',
        menu_delete_exist_yn: 'N',
        menu_update_yn: 'N',
        menu_delete_yn: 'N',
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectModalTitle('화면 목록')
      setSelectModalOpen(true);
      setSelectMenuData({
        id : object.row.id,
        menu_id : object.row.menu_id,
        item_in_out_type: object.row.menu_name,
        menu_update_exist_yn: object.row.menu_update_exist_yn,
        menu_delete_exist_yn: object.row.menu_delete_exist_yn,
        menu_update_yn: object.row.menu_update_yn,
        menu_delete_yn: object.row.menu_delete_yn,
        row_type: object.row.row_type,
        update_type: object.row.update_type
      })
    }
  };

  const menuDeleteClick = (object) => {
    //화면 삭제 버튼
    setUpdateMenuRows((updateMenuRows) => updateMenuRows.filter((data) => data.id !== object.row.id));
    setMenuRows((menuRows) => menuRows.filter((data) => data.id !== object.row.id));
  };

  const handleUserOnCellClick = (params) => {
    if(params.field === 'user_name'){
      setSelectUserModalTitle('사용자 목록')
      setSelectUserModalOpen(true);
      setSelectUserData({
        id : params.row.id,
        dept_id : params.row.dept_id,
        position : params.row.position,
        duty : params.row.duty,
        user_id : params.row.user_id,
        user_name: params.row.user_name,
        row_type: params.row.row_type,
        update_type: params.row.update_type
      });
    }
  }

  const handleUserClick = (object) => {
    if(object.id !== selectUserData.user_id){
      var doubleYN = 'N'; //updateRows에 있는값인지 확인함.
      for (let i = 0; i < userRows.length; i++) {
        if(userRows[i].user_id === object.id && selectUserData.id !== userRows[i].id && object.id !== ''){
          doubleYN = 'Y';
        }
      }

      if(doubleYN === 'Y'){
        Swal.fire({
          title: '<p style="color:red">담당자 '+object.user_name+' 중복</p>',
          text: '추가된 담당자이므로, 중복으로 추가할 수 없습니다.',
          confirmButtonText: '확인'
        });
      }else{
        processUserRowUpdate(
          {
            id : selectUserData.id,
            dept_id : '',
            position : '',
            duty : '',
            user_id : object.id,
            user_name: object.user_name,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          },
          {
            id : selectUserData.id,
            dept_id : selectUserData.dept_id,
            position: selectUserData.position,
            duty: selectUserData.duty,
            user_id: selectUserData.user_id,
            user_name: selectUserData.user_name,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          }
        );
      }
    }
  }

  const userAddClick = (object) => {
    //사용자 추가 버튼
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        dept_id: '',
        position: '',
        duty: '',
        user_id: '',
        user_name: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  };

  const userDeleteClick = (object) => {
    //화면 삭제 버튼
    setUpdateUserRows((updateUserRows) => updateUserRows.filter((data) => data.id !== object.row.id));
    setUserRows((userRows) => userRows.filter((data) => data.id !== object.row.id));
  };

  const handleResourceOnCellClick = (params) => {
    if(params.field === 'resource_name'){
      setSelectResourceModalTitle('자원 목록')
      setSelectResourceModalOpen(true);
      setSelectResourceData({
        id : params.row.id,
        resource_id: params.row.resource_id,
        resource_name: params.row.resource_name,
        resource_number: params.row.resource_number,
        resource_workplace_name: params.row.resource_workplace_name,
        resource_location: params.row.resource_location,
        row_type: params.row.row_type,
        update_type: params.row.update_type
      });
    }
  }

  const handleResourceClick = (object) => {
    if(object.id !== selectResourceData.user_id){
      var doubleYN = 'N'; //updateRows에 있는값인지 확인함.
      for (let i = 0; i < resourceRows.length; i++) {
        if(resourceRows[i].resource_id === object.id && selectResourceData.id !== resourceRows[i].id && object.id !== ''){
          doubleYN = 'Y';
        }
      }

      if(doubleYN === 'Y'){
        Swal.fire({
          title: '<p style="color:red">자원 '+object.resource_name+' 중복</p>',
          text: '추가된 자원이므로, 중복으로 추가할 수 없습니다.',
          confirmButtonText: '확인'
        });
      }else{
        processResourceRowUpdate(
          {
            id : selectResourceData.id,
            resource_id: object.id,
            resource_name: object.resource_name,
            resource_number: object.resource_number,
            resource_workplace_name: object.resource_workplace_name,
            resource_location: object.resource_location,
            row_type: selectResourceData.row_type,
            update_type: selectResourceData.update_type
          },
          {
            id : selectResourceData.id,
            resource_id : selectResourceData.resource_id,
            resource_name: selectResourceData.resource_name,
            resource_number: selectResourceData.resource_number,
            resource_workplace_name: selectResourceData.resource_workplace_name,
            resource_location: selectResourceData.resource_location,
            row_type: selectResourceData.row_type,
            update_type: selectResourceData.update_type
          }
        );
      }
    }
  }

  const resouceAddClick = (object) => {
    //자원 추가 버튼
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setResourceRows((resourceRows) => [...resourceRows, { 
        id: Number(appStore.getMaxListID(resourceRows))+1,
        resource_id: '',
        resource_name: '',
        resource_number: '',
        resource_workplace_name: '',
        resource_location: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectResourceModalTitle('자원 목록')
      setSelectResourceModalOpen(true);
      setSelectResourceData({
        id : object.row.id,
        resource_id: object.row.resource_id,
        resource_name: object.row.resource_name,
        resource_number: object.row.resource_number,
        resource_workplace_name: object.row.resource_workplace_name,
        resource_location: object.row.resource_location,
        row_type: object.row.row_type,
        update_type: object.row.update_type
      });
    }
  };

  const resouceDeleteClick = (object) => {
    //화면 삭제 버튼
    setUpdateResourceRows((updateResourceRows) => updateResourceRows.filter((data) => data.id !== object.row.id));
    setResourceRows((resourceRows) => resourceRows.filter((data) => data.id !== object.row.id));
  };

  const processMenuRowUpdate = (newRow, oldRow) => {
    //화면 Rows Update
    const newUpdateDataArray = { ...newRow, update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { ...newRow, update_type: 'N' }; // 값 변경이 없는 경우

    if(newRow.menu_id !== oldRow.menu_id || newRow.menu_name !== oldRow.menu_name || newRow.menu_update_yn !== oldRow.menu_update_yn || newRow.menu_delete_yn !== oldRow.menu_delete_yn){
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_menu_id = '';
      var row_menu_name = '';
      var row_menu_update_exist_yn = 'N';
      var row_menu_delete_exist_yn = 'N';
      var row_menu_update_yn = 'N';
      var row_menu_delete_yn = 'N';

      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if(newRow.menu_id !== '' || newRow.menu_name !== '' || newRow.menu_update_exist_yn !== 'N' || newRow.menu_delete_exist_yn !== 'N' || newRow.menu_update_yn !== 'N' || newRow.menu_delete_yn !== 'N'){
          row_menu_id = newRow.menu_id;
          row_menu_name = newRow.menu_name;
          row_menu_update_exist_yn = newRow.menu_update_exist_yn;
          row_menu_delete_exist_yn = newRow.menu_delete_exist_yn;
          row_menu_update_yn = newRow.menu_update_yn;
          row_menu_delete_yn = newRow.menu_delete_yn;
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        menuRows.map((data) => data.id === newRow.id 
          && (data.menu_id !== newRow.menu_id || data.menu_name !== newRow.menu_name || data.menu_update_exist_yn !== newRow.menu_update_exist_yn || data.menu_delete_exist_yn !== newRow.menu_delete_exist_yn || data.menu_update_yn !== newRow.menu_update_yn || data.menu_delete_yn !== newRow.menu_delete_yn)?
          (
            row_menu_id = data.menu_id,
            row_menu_name = data.menu_name,
            row_menu_update_exist_yn = data.menu_update_exist_yn,
            row_menu_delete_exist_yn = data.menu_delete_exist_yn,
            row_menu_update_yn = data.menu_update_yn,
            row_menu_delete_yn = data.menu_delete_yn
          ):""
        )
      }
      
      if(row_menu_id === '' && row_menu_name === '' && row_menu_update_exist_yn === 'N' && row_menu_delete_exist_yn === 'N' && row_menu_update_yn === 'N' && row_menu_delete_yn === 'N'){
        // 1. 값이 수정되지 않은 경우.
        if(updateMenuRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          //console.log('[updateRows 원복] ' + updateMenuRows.length);
          setUpdateMenuRows(updateMenuRows.filter((data) => data.id !== newRow.id));
          setMenuRows(menuRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateMenuRows.length; i++) {
          if(updateMenuRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updatePartnerRows.length);
          setUpdateMenuRows(updateMenuRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setMenuRows(menuRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updatePartnerRows.length);
          setUpdateMenuRows(prevRows => [...prevRows, newUpdateDataArray]);
          setMenuRows(menuRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const processUserRowUpdate = (newRow, oldRow) => {
    //화면 Rows Update
    var newUpdateDataArray = { ...newRow, update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { ...newRow, update_type: 'N' }; // 값 변경이 없는 경우

    if(newRow.dept_id !== oldRow.dept_id || newRow.position !== oldRow.position || newRow.duty !== oldRow.duty || newRow.user_id !== oldRow.user_id || newRow.user_name !== oldRow.user_name){
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_dept_id = '';
      var row_position = '';
      var row_duty = '';
      var row_user_id = '';
      var row_user_name = '';

      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if(newRow.dept_id !== '' || newRow.position !== '' || newRow.duty !== '' || newRow.user_id !== '' || newRow.user_name !== ''){
          row_dept_id = newRow.dept_id;
          row_position = newRow.position;
          row_duty = newRow.duty;
          row_user_id = newRow.user_id;
          row_user_name = newRow.user_name;
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        userRows.map((data) => data.id === newRow.id 
          && (data.dept_id !== newRow.dept_id || data.position !== newRow.position || data.duty !== newRow.duty || data.user_id !== newRow.user_id || data.user_name !== newRow.user_name)?
          (
            row_dept_id = data.dept_id,
            row_position = data.position,
            row_duty = data.duty,
            row_user_id = data.user_id,
            row_user_name = data.user_name
          ):""
        )
      }
      
      if(row_dept_id === '' && row_position === '' && row_duty === '' && row_user_id === '' && row_user_name === ''){
        // 1. 값이 수정되지 않은 경우.
        if(updateUserRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          //console.log('[updateRows 원복] ' + updateMenuRows.length);
          setUpdateUserRows(updateUserRows.filter((data) => data.id !== newRow.id));
          setUserRows(userRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateUserRows.length; i++) {
          if(updateUserRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if((newRow.dept_id !== oldRow.dept_id || newRow.position !== oldRow.position || newRow.duty !== oldRow.duty) && oldRow.user_id === newRow.user_id){
          var joongbok_yn = 'N';
          for (let i = 0; i < updateUserRows.length; i++) {
            if(updateUserRows[i].dept_id === newRow.dept_id && updateUserRows[i].position === newRow.position && updateUserRows[i].duty === newRow.duty){
              joongbok_yn = 'Y';
            }
          }
          if(joongbok_yn === 'Y'){
            Swal.fire({
              title: '<p style="color:red">부서, 직위, 직책 중복</p>',
              text: '부서, 직위, 직책이 중복된 데이터이므로, 원복합니다.',
              confirmButtonText: '확인'
            });
            newUpdateDataArray = { ...oldRow };
          }else{
            newUpdateDataArray = { ...newRow, user_id:'', user_name: '', update_type: 'U' };
          }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updatePartnerRows.length);
          setUpdateUserRows(updateUserRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updatePartnerRows.length);
          setUpdateUserRows(prevRows => [...prevRows, newUpdateDataArray]);
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const processResourceRowUpdate = (newRow, oldRow) => {
    //화면 Rows Update
    const newUpdateDataArray = { ...newRow, update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { ...newRow, update_type: 'N' }; // 값 변경이 없는 경우

    if(newRow.resource_id !== oldRow.resource_id){
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_resource_id = '';

      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if(newRow.resource_id !== ''){
          row_resource_id = newRow.resource_id;
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        resourceRows.map((data) => data.id === newRow.id 
          && (data.resource_id !== newRow.resource_id)?
          (
            row_resource_id = data.resource_id
          ):""
        )
      }
      
      if(row_resource_id === ''){
        // 1. 값이 수정되지 않은 경우.
        if(updateResourceRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          //console.log('[updateRows 원복] ' + updateMenuRows.length);
          setUpdateResourceRows(updateResourceRows.filter((data) => data.id !== newRow.id));
          setResourceRows(resourceRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateResourceRows.length; i++) {
          if(updateResourceRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updatePartnerRows.length);
          setUpdateResourceRows(updateResourceRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setResourceRows(resourceRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updatePartnerRows.length);
          setUpdateResourceRows(prevRows => [...prevRows, newUpdateDataArray]);
          setResourceRows(resourceRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };

  return (
    <PCModal onClose={onClose} title={title}>
      <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
        <TabContext value={tabID}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
              <Tab label="권한 정보" value="1" />
              <Tab label="권한별 화면" value="2" />
              { inputs.authority_type === '1'? <Tab label="계정권한" value="3" />:<Tab label="계정권한" value="3" disabled /> }
              { inputs.authority_type === '2'? <Tab label="자원권한" value="4" />:<Tab label="자원권한" value="4" disabled /> }
            </TabList>
          </Box>
          <TabPanel value="1" ref={tabPanelRef}>
            <table className="ModalTABLE">
              <tbody>
                <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">권한명<span className="essential">*</span></div>
                      <div className="modal_filed_input">
                        <input type="text" placeholder="권한명" value={inputs.authority_name} name="authority_name" onChange={(e) => onChange(e) } autoComplete="off" />
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">권한유형<span className="essential">*</span></div>
                      <div className="modal_filed_input">
                        <Select className="modal_filed_input_select" placeholder="권한유형" value={authorityTypeModalOption.filter(function (option) { return option.value === inputs.authority_type;  })} onChange={(e) => onSelectChange('authority_type',e.value)} options={authorityTypeModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_filed">
                      <div className="modal_filed_title">권한설명</div>
                      <div className="modal_filed_input">
                        <textarea placeholder="권한설명" name="authority_desc" value={inputs.authority_desc} onChange={(e) => onChange(e) } style={{width: '768px', height: '150px', marginTop:'10px', border:'2px lightgrey solid', borderRadius: '5px', fontSize:'17px', fontFamily:'none', resize:'none'}} autoComplete="off">
                        </textarea>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </TabPanel>
          <TabPanel value="2" style={ { height: tabPanelHeight } }>
            <div className="modal_grid">
              <DataGrid
                apiRef={apiRef}
                rows={menuRows}
                columns={menuColumns}
                columnVisibilityModel={menuColumnVisibilityModel}
                editMode='cell'  
                processRowUpdate={processMenuRowUpdate}        
                onProcessRowUpdateError={(error) => error}
                AlternatingRowBackground="LavenderBlush"
                rowsPerPageOptions={[20, 50, 100]}
                initialState={{ 
                    density: 'compact'
                }}
                slots={{
                    noRowsOverlay: GridNoRow,
                }}
                onCellClick={handleMenuOnCellClick}
                isCellEditable={(params) => params.row.menu_update_exist_yn === 'Y' || params.row.menu_delete_exist_yn === 'Y'}
                disableColumnSorting 
              />
            </div>
          </TabPanel>
          <TabPanel value="3" style={ { height: tabPanelHeight } }>
            <div className="modal_grid">
              <DataGrid
                apiRef={apiRef}
                rows={userRows}
                columns={userColumns}
                columnVisibilityModel={userColumnVisibilityModel}
                editMode='cell'  
                processRowUpdate={processUserRowUpdate}        
                onProcessRowUpdateError={(error) => error}
                AlternatingRowBackground="LavenderBlush"
                rowsPerPageOptions={[20, 50, 100]}
                initialState={{ 
                    density: 'compact'
                }}
                slots={{
                    noRowsOverlay: GridNoRow,
                }}
                onCellClick={handleUserOnCellClick}
                disableColumnSorting 
              />
            </div>
          </TabPanel>
          <TabPanel value="4" style={ { height: tabPanelHeight } }>
            <div className="modal_grid">
              <DataGrid
                apiRef={apiRef}
                rows={resourceRows}
                columns={resourceColumns}
                columnVisibilityModel={resourceColumnVisibilityModel}
                editMode='cell'  
                processRowUpdate={processResourceRowUpdate}        
                onProcessRowUpdateError={(error) => error}
                AlternatingRowBackground="LavenderBlush"
                rowsPerPageOptions={[20, 50, 100]}
                initialState={{ 
                    density: 'compact'
                }}
                slots={{
                    noRowsOverlay: GridNoRow,
                }}
                onCellClick={handleResourceOnCellClick}
                disableColumnSorting 
              />
            </div>
          </TabPanel>
        </TabContext>
        <table className="ModalTABLE">
          <tbody>
            <tr>
              <td className="ModalTD" colSpan={2}>
                <div className="modal_action">
                  <div className="modal_button">
                    <Button 
                      onClick={()=> { onClose?.(); }}
                      className="btn-p"
                      sx={{  
                          m: 1, 
                          fontSize: 15, 
                          color: "white", 
                          borderColor: "#808080", 
                          backgroundColor: "#808080",
                          ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                      }} 
                      variant="outlined">
                      닫기
                    </Button>
                  </div>
                  <div className="modal_button">
                    {MenuUpdateYN === 'Y' &&
                    <Button 
                      onClick={handleSave}
                      className="btn-p btn-u"
                      sx={{  
                          m: 1, 
                          fontSize: 18, 
                          color: "white", 
                          borderColor: "#FF3636", 
                          backgroundColor: "#FF3636",
                          ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                      }} 
                      variant="outlined">
                      등록
                    </Button> }
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {isSelectModalOpen && (<MenuSelectModal
          onClose={() => {
              setSelectModalOpen(false);
          }}
          title={selectmodalTitle}
          handleMenuClick={handleMenuClick}
          />)}
      {isSelectUserModalOpen && (<UserSelectModal
          onClose={() => {
              setSelectUserModalOpen(false);
          }}
          title={selectusermodalTitle}
          handleUserClick={handleUserClick}
          />)}
      {isSelectResourceModalOpen && (<ResourceSelectModal
          onClose={() => {
              setSelectResourceModalOpen(false);
          }}
          title={selectresourcemodalTitle}
          handleResourceClick={handleResourceClick}
          />)}
    </PCModal>
  );
}

export default AuthorityRegModal;